import React, { useState, useEffect } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { useNavigate } from 'react-router-dom';
import AdvertiserPanel from "./AdvertiserPanel";
import AdminNavbar from "./Layout/AdminNavbar";
import "../Styles/Advertiser.css";
import Select from "react-select";
import MessageHeading from "../Pages/CommonComponents/MessageHeading";
import MessageBox from "../../components/MessageBox";
import AdvertisementTimeSlot from "../Components/AdvertisementTimeSlot";
import ResponseLoader from "../../components/Loader/ResponseLoader";

const AdvertisementCreate = () => {
  const access_token = localStorage.getItem("access_token");
  const navigate = useNavigate();

  const [uploadType, setUploadType] = useState([]);
  const [position, setPosition] = useState([]);
  const [category, setCategory] = useState([]);
  const [advertisement_videos_upload, setAdvertisement_videos_upload] = useState("");
  const [showOverlay, setShowOverlay] = useState(false);

  const [store, setStore] = useState({
    active: 0,
    selectType: null,
    adsName: "",
    adsUrl: '',
    redirectUrl: "",
    position: null,
    category: null
  });
  const [errors, setErrors] = useState({});

  const [touched, setTouched] = useState({
    selectType: false,
    adsUrl: false,
    adsFile: false,
    redirectUrl: false,
    position: false,
    category: false,
    adsName: false,
    skip_duration: false,
  });

  const headers = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + access_token,
    "Access-Control-Allow-Origin": "*",
  };

  const fetchOptions = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_Baseurl}/advertiser/advertisement-create`,
        { headers }
      );
      const result = response.data.data;
      setUploadType(result.ads_upload_type);
      setPosition(result.ads_position_play);
      setCategory(result.admin_ads_category);
    } catch (error) {
      console.log(error);
    }
  };

  // const handleFileChange = (e) => {
  //   const file = e.target.files?.[0];
  //   setAdvertisement_videos_upload(file);
  //   setTouched(prev => ({ ...prev, adsFile: true }));
  // };

  const [videoError, setVideoError] = useState("");

  const handleFileChange = (e) => {
    const file = e.target.files?.[0];

    if (file && file.type.startsWith('video/')) {
      setAdvertisement_videos_upload(file);
      setVideoError("");
    } else {
      setAdvertisement_videos_upload(null);
      setVideoError("Only video files are allowed.");
    }

    setTouched(prev => ({ ...prev, adsFile: true }));
  };

  const isHttpsUrl = (url) => {
    return url.startsWith("https://");
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    // Don't trim adsName to allow spaces, but trim URLs to prevent issues
    const processedValue = (name === 'adsUrl' || name === 'redirectUrl') ? value.trim() : value;
    setStore(prev => ({ ...prev, [name]: processedValue }));
    setTouched(prev => ({ ...prev, [name]: true }));
  };


  const handleSelectType = (option) => {
    setStore(prev => ({ ...prev, selectType: option?.value }));
    setTouched(prev => ({ ...prev, selectType: true }));
  };

  const handleSelectedPosition = (option) => {
    setStore(prev => ({ ...prev, position: option?.value }));
    setTouched(prev => ({ ...prev, position: true }));
  };

  const handleSelectedCategory = (option) => {
    setStore(prev => ({ ...prev, category: option?.value }));
    setTouched(prev => ({ ...prev, category: true }));
  };

  // const validateFields = () => {
  //   const errors = {};
  //   if (!store?.selectType) errors.selectType = "Upload type is required";
  //   if (!store?.adsName) errors.adsName = "Advertisement name is required";
  //   if (!store?.category) errors.category = "Category is required";
  //   if (!store?.position) errors.position = "Position is required";
  //   if (store?.selectType === "tag_url") {
  //     if (!store?.adsUrl) errors.adsUrl = "Ad URL is required";
  //   } else {
  //     if (!advertisement_videos_upload) errors.adsFile = "Video file is required";
  //     // if (!store?.redirectUrl) errors.redirectUrl = "Redirect URL is required";
  //   }
  //   return errors;
  // };

  const validateFields = () => {

    const errors = {};
    const urlPattern = /^(https?:\/\/)[^\s/$.?#].[^\s]*$/i;

    if (!store?.selectType) errors.selectType = "Upload type is required";
    if (!store?.adsName) errors.adsName = "Advertisement name is required";
    if (!store?.category) errors.category = "Category is required";
    if (!store?.position) errors.position = "Position is required";

    if (store?.selectType === "tag_url") {
      if (!store?.adsUrl) {
        errors.adsUrl = "Ad URL is required";
      } else if (!urlPattern.test(store.adsUrl)) {
        errors.adsUrl = "Ad URL must start with http:// or https://";
      }
    } else {
      if (!advertisement_videos_upload) {
        errors.adsFile = "Video file is required";
      }

      // ✅ Only validate redirectUrl format if it's filled
      if (store?.redirectUrl && !urlPattern.test(store.redirectUrl)) {
        errors.redirectUrl = "Redirect URL must start with http:// or https://";
      }
    }

    return errors;
  };



  const saveData = async () => {
    const validationErrors = validateFields();
    setErrors(validationErrors);
    if (Object.keys(validationErrors).length > 0) {
      setTouched({
        selectType: true,
        adsUrl: true,
        adsFile: true,
        redirectUrl: true,
        adsName: true,
        category: true,
        position: true,
      });
      // toast.error("Please fix the highlighted errors.");
      return;
    }

    const formData = {
      ads_name: store?.adsName,
      ads_redirection_url: store?.redirectUrl,
      ads_upload_type: store?.selectType,
      ads_position: store?.position,
      ads_category: store?.category,
      ads_path: store?.adsUrl || "",
      skip_duration: Number(store?.skip_duration) || "",
    };

    setShowOverlay(true);
    try {
      // Check upload limits using new centralized API
      // const limitCheckRes = await axios.get(
      //   `${process.env.REACT_APP_Baseurl}/advertiser/advertisement/upload-limit-status`,
      //   { headers }
      // );

      // const uploadStatus = limitCheckRes?.data?.data;

      // // Simple check: API handles all validation and returns final status
      // if (!uploadStatus?.can_upload) {
      //   toast.warning(uploadStatus?.message || "Your plan limit has been reached. Please upgrade your plan.");
      //   setShowOverlay(false);
      //   navigate('/plans');
      //   return;
      // }

      const response = await axios.post(`${process.env.REACT_APP_Baseurl}/advertiser/advertisement-store`, formData, { headers });
      const id = response.data.data.advertisement.id;

      if (advertisement_videos_upload) {
        const formDataUpload = new FormData();
        formDataUpload.append("advertisement_videos_upload", advertisement_videos_upload);

        await axios.patch(
          `${process.env.REACT_APP_Baseurl}/advertiser/advertisement-upload/${id}`,
          formDataUpload,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: "Bearer " + access_token,
            },
          }
        );
      }

      toast.success("Advertisement Stored Successfully");
      setShowOverlay(false);
      setTimeout(() => navigate("/ads-list"), 500);
    } catch (error) {
      const errorMessage = error?.response?.data?.errors?.[0]?.msg || error.response?.data?.message || "Error saving data";
      setShowOverlay(false);
      toast.error(errorMessage);
    }
  };

  useEffect(() => {
    fetchOptions();
  }, []);

  return (
    <AdvertiserPanel>
      <div className="p-3 rounded-3">
        {showOverlay && <ResponseLoader />}
        <div className="theme-bg-color p-3 mt-3 rounded-2 bootstrapTable multi-delete-width">
          <MessageHeading text={"Upload Advertisements"} className="advertiserHeading" />
          <div className="row">
            <div className="col-md-6">
              <div className="rounded-3 theme-bg-color px-2 ps-md-0">
                <label className="before-star">Advertisement Name</label>
                <input
                  type="text"
                  name="adsName"
                  id="advertiserName"
                  value={store?.adsName}
                  onChange={handleChange}
                  placeholder="Enter advertisement name"
                  className={`custom-input form-control mt-2 ${touched?.adsName && !store?.adsName ? "" : ""}`}
                />
                {touched?.adsName && !store?.adsName && <small className="errorred">Advertisement name is required</small>}




                <label className="before-star mt-2">Advertisement Upload Type</label>
                <Select
                  options={uploadType?.map(option => ({ value: option.value, label: option.name }))}
                  onChange={handleSelectType}
                  id="advertiserSelectedUploadType"
                  className={`custom-input custom-placeholder bg-transparent mt-2 ${touched?.selectType && !store?.selectType ? "border border-danger-test" : ""}`}
                />
                {touched?.selectType && !store?.selectType && <small className="errorred">Upload type is required</small>}

                {store?.selectType === "tag_url" ? (
                  <>
                    <MessageBox classname="advertiserSubHeading theme-text-color d-block position-relative my-3 before-star" text="Ads URL" />
                    <input
                      type="text"
                      name="adsUrl"
                      id="advertiserAdsUrl"
                      value={store?.adsUrl}
                      onChange={handleChange}
                      onBlur={() => setTouched(prev => ({ ...prev, adsUrl: true }))}
                      placeholder="Paste the ad URL here"
                      className={`form-control py-3 ${touched?.adsUrl && !isHttpsUrl(store?.adsUrl) ? "" : ""}`}
                    />

                    {touched?.adsUrl && !isHttpsUrl(store?.adsUrl) && (
                      <small className="errorred">{errors.adsUrl}</small>
                    )}

                  </>
                ) : store?.selectType ? (
                  <>
                    <MessageBox classname="advertiserSubHeading theme-text-color d-block position-relative my-3 before-star" text="Ads Video Upload" />
                    <input
                      type="file"
                      className={`form-control ${touched?.adsFile && !advertisement_videos_upload ? "" : ""}`}
                      name="adsFile"
                      id="advertiserAdsFile"
                      accept="video/*"
                      onChange={handleFileChange}
                    />

                    {touched?.adsFile && !advertisement_videos_upload && (
                      <small className="errorred">
                        {videoError || "Video file is required"}
                      </small>
                    )}

                    <MessageBox classname="advertiserSubHeading theme-text-color d-block position-relative my-3" text="Ads Redirect URL" />
                    <input
                      type="text"
                      name="redirectUrl"
                      id="advertiserRedirectUrl"
                      value={store?.redirectUrl}
                      onChange={handleChange}
                      // onBlur={() => setTouched(prev => ({ ...prev, redirectUrl: true }))}
                      placeholder="https://example.com"
                      className={`form-control ${touched?.redirectUrl && !store?.redirectUrl ? "" : ""}`}
                    />
                    {touched?.redirectUrl && errors?.redirectUrl && (
                      <small className="errorred">{errors.redirectUrl}</small>
                    )}  </>
                ) : null}

              </div>
            </div>

            <div className="col-md-6">
              <div className="rounded-3 theme-bg-color px-2 ps-md-0">

                <label className="before-star">Advertisement Category</label>
                <Select
                  options={category?.map(option => ({ value: option.id, label: option.name }))}
                  onChange={handleSelectedCategory}
                  id="advertiserSelectedCategory"
                  className={`mt-2 ${touched?.category && !store?.category ? "border border-danger-test" : ""}`}
                />
                {touched?.category && !store?.category && <small className="errorred">Category is required</small>}

                <label className="mt-3 before-star">Advertisement Position</label>
                <Select
                  options={position?.map(option => ({ value: option.value, label: option.name }))}
                  onChange={handleSelectedPosition}
                  id="advertiserSelectedPosition"
                  className={`mt-2 ${touched?.position && !store?.position ? "border border-danger-test" : ""}`}
                />
                {touched?.position && !store?.position && <small className="errorred">Position is required</small>}

                {store?.selectType !== "tag_url" &&
                  <>
                    <label className="mt-3">Advertisement Skip Time</label>
                    <input
                      type="number"
                      name="skip_duration"
                      id="advertiserName"
                      value={store?.skip_duration}
                      onChange={handleChange}
                      placeholder="Enter skip time in seconds"
                      className={`form-control py-3 mt-2 ${touched?.skip_duration && !store?.skip_duration ? "" : ""}`}
                    />
                  </>
                }
              </div>
            </div>
          </div>
        </div>

        <div className="d-flex align-items-center justify-content-end gap-2 mt-3">
          <button className="px-3 py-2 theme-button-bg-color rounded-2 next-submit" id="advertiserSubmitButton" onClick={saveData}>
            Submit
          </button>
        </div>
      </div>
    </AdvertiserPanel>
  );
};

export default AdvertisementCreate;
